import React, { useEffect, useContext, useState } from "react";
import {
  Field,
  Divider,
  Card,
  CardHeader,
  Caption1Strong,
  CardPreview,
  Radio,
  RadioGroup,
  ToolbarButton,
} from "@fluentui/react-components";
import { SettingsRegular } from "@fluentui/react-icons";
import { AppContext } from "./context/AppContext";
import { getProfileFromStorage } from "../../utils/profilepreferencesave";
import { getStringFromStorage } from "../../utils/storagehelper";
import { ProfileSettings, WorkbookSettings } from "../../types/app.storage.enums";
import SubHeader from "./SubHeader";
import { useSheetOptionStyles as useErrorHandlingStyles, useStackClassName } from "./style/sheetoptions.style";
import { getStringFromWorkbookStorage, setStringToWorkbookStorage } from "../../utils/officestoragehelper";
import { isValidUser } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { hashNameCalculate, renameBurgissToPrivatei, renamePrivateiToBurgiss } from "../../utils/officedocumenthelper";
import Loader from "./Loader";
const ErrorHandling = () => {
  const [isLoading, setIsLoading] = useState(false);
  const styles = useErrorHandlingStyles();
  const context = useContext(AppContext);
  const [errorType, setErrorType] = useState("");
  const navigate = useNavigate();
  const radioGroupChangeHandler = (_e, data) => {
    if (isValidUser()) {
      navigate("/home");
    } else {
      setErrorType(data.value);
      setStringToWorkbookStorage(WorkbookSettings.ErrorHandlingType, data.value === "burgiss");
    }
  };

  const Calculate = async () => {
    // Check which radio button is selected
    console.log("Selected radio button:", errorType);
    
    // Handle different actions based on selected radio button
    switch (errorType) {
      case "burgiss":
        // Handle "Return Burgiss Errors" option
        console.log("Processing: Return Burgiss Errors");
        break;
      case "excel":
        // Handle "Fix excel vulnerabilities" option
        console.log("Processing: Fix excel vulnerabilities");

        setIsLoading(true);
        await hashNameCalculate()
          .then(() => {
            setIsLoading(false);
          })
          .catch((error) => {
            console.log("Error: " + error);
            setIsLoading(false);
          });

        break;
      case "rmPrivatei":
        // Handle "Rename Fn (Burgiss to Privatei)" option
        console.log("Processing: Rename Fn (Burgiss to Privatei)");
        setIsLoading(true);
        await renameBurgissToPrivatei()
          .then(() => {
            setIsLoading(false);
          })
          .catch((error) => {
            console.log("Error: " + error);
            setIsLoading(false);
          });
        break;
      case "rmBurgiss":
        // Handle "Rename Fn (Privatei to Burgiss)" option
        console.log("Processing: Rename Fn (Privatei to Burgiss)");
        setIsLoading(true);
        await renamePrivateiToBurgiss()
          .then(() => {
            setIsLoading(false);
          })
          .catch((error) => {
            console.log("Error: " + error);
            setIsLoading(false);
          });
        break;
      default:
        console.log("No option selected");
        return;
    }
  };
  
  useEffect(() => {
    if (isValidUser()) {
      navigate("/home");
    } else {
      if (getStringFromStorage(ProfileSettings.ProfileId) && !context.selectedProfile) {
        getProfileFromStorage().then((profile) => {
          context.setSelectedProfile(profile);
        });
      }
      getStringFromWorkbookStorage(WorkbookSettings.ErrorHandlingType).then((value) => {
        setErrorType(value ? "burgiss" : "excel");
      });
    }
  }, []);

  return (
    <>
      <SubHeader title="Error Handling" subtitle="Settings" icon={<SettingsRegular></SettingsRegular>}></SubHeader>
      <div className={styles.root}>
        <Card className={styles.card} appearance="subtle">
          <CardHeader
            header={<Caption1Strong>Note: This settings will be applicable for Workbook</Caption1Strong>}
          ></CardHeader>
          <CardPreview className={styles.cardPreview}>
            <div className={useStackClassName()}>
              <Field className={styles.inputcheckbox}>
                <RadioGroup value={errorType} onChange={radioGroupChangeHandler}>
                  <Divider className={styles.dividerPT}></Divider>
                  <Radio label="Return Burgiss Errors" value="burgiss" />
                  <Divider className={styles.dividerPT}></Divider>
                  <Radio label="Fix excel vulnerabilities" value="excel" />
                  <Divider className={styles.dividerPT}></Divider>
                  <Radio label="Rename Fn (Burgiss to Privatei)" value="rmPrivatei" />
                  <Divider className={styles.dividerPT}></Divider>
                  <Radio label="Rename Fn (Privatei to Burgiss)" value="rmBurgiss" />
                  <Divider className={styles.dividerPT}></Divider>
                </RadioGroup>
              </Field>
              <div className={styles.noteContainer}>
                {" "}
                <Caption1Strong>Note: Click below to Fix excel vulnerabilities.</Caption1Strong>
                {!isLoading && (
                  <ToolbarButton className={styles.ErrorButton} onClick={() => Calculate()}>
                    Submit
                  </ToolbarButton>
                )}
                {isLoading && <Loader></Loader>}
              </div>
            </div>
          </CardPreview>
        </Card>
      </div>
    </>
  );
};

export default ErrorHandling;
